import {
  AddContactCustomFieldApiParams,
  CreateCustomFieldApiParams as CreateContactCustomFieldApiParams,
  DeleteCompanyCustomFieldApiParams,
  DeleteContactCustomFieldApiParams,
  DeleteCustomFieldApiParams,
  GetCompanyCustomFieldsApiParams,
  GetContactCustomFieldsApiParams,
  GetDefaultCustomFields,
  GetDefaultCustomFieldsValues,
  UpdateCustomCompanyFieldApiParams,
  UpdateCustomFieldApiParams,
  UpdateDefaultCustomFieldsValues,
} from './types';
import { useCallback } from 'react';
import apiClient from '../axiosClient';

export function useGetCompanyCustomFieldsApi(): GetCompanyCustomFieldsApiParams {
  return useCallback(params => apiClient.get(`/company-metadata`, {params}), []);
}

export function useUpdateCustomCompanyFieldApi(): UpdateCustomCompanyFieldApiParams {
  return useCallback((params, companyId) => apiClient.put(`/company-metadata/company/${companyId}`, params), []);
}

export function useDeleteCompanyCustomFieldApi(): DeleteCompanyCustomFieldApiParams {
  return useCallback((metadataId, companyId) => apiClient.delete(`/company-metadata/company/${companyId}`, {data: {metadataId}}), []);
}

export function useGetContactCustomFieldsApi(): GetContactCustomFieldsApiParams {
  return useCallback(params => apiClient.get(`/contact-metadata`, {params}), []);
}

export function useCreateContactCustomFieldApi(): CreateContactCustomFieldApiParams {
  return useCallback((params, companyId) => apiClient.post(`/contact-metadata`, params, {params: {companyId}}), []);
}

export function useUpdateContactCustomFieldApi(): UpdateCustomFieldApiParams {
  return useCallback((params, metadataId) => apiClient.put(`/contact-metadata/${metadataId}`, params), []);
}

export function useDeleteContactCustomFieldApi(): DeleteCustomFieldApiParams {
  return useCallback((id, companyId) => apiClient.delete(`/contact-metadata`, {params: {companyId}, data: {ids: [id]}}), []);
}

export function useAddContactCustomField(): AddContactCustomFieldApiParams {
  return useCallback((params, contactId) => apiClient.put(`/contact-metadata/contact/${contactId}`, params), []);
}

export function useDeleteContactCustomField(): DeleteContactCustomFieldApiParams {
  return useCallback((metadataIds, contactId) => apiClient.delete(`/contact-metadata/contact/${contactId}`, {data: {metadataIds}}), []);
}

export function useGetDefaultCustomFieldsValuesApi(): GetDefaultCustomFieldsValues {
  return useCallback(params => apiClient.get(`/templates/default-values`, {params}), []);
}

export function useUpdateDefaultCustomFieldsValues() : UpdateDefaultCustomFieldsValues {
  return useCallback((params, companyId) => apiClient.patch(`/templates/default-values`, params, {params: {companyId}}), []);
}

export function useGetDefaultCustomFieldsApi(): GetDefaultCustomFields {
  return useCallback(params => apiClient.get(`/templates`, {params}), []);
}
